module.exports = __webpack_public_path__ + "img/Nan.93326bd3.jpeg";